// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__Nvypg","inline":"skeleton_inline__75_oo"};